import { useRouter } from 'next/router';
import { useFormContext, useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FieldRequirementTypeMap, TICKET_FORM_FIELDS_KEY, TicketSystemfieldNamesMap } from '../../model/types';
import { getFieldRuleByKey } from '../../utils/forms/formHelper.util';
import { defineMode } from '../../utils/forms/formHelpers';
import useAgentFormById, { UIFieldRuleOnForm } from './useAgentFormById';
import useFieldDefinitionListFromAgentForm from './useFieldDefinitionListFromAgentForm';

const hookFormFriendlyFieldKey = (key: string) =>
    TICKET_FORM_FIELDS_KEY + '.' + key.replace(new RegExp('\\.', 'gi'), '$');

const useRequiredFormFields = () => {
    const { asPath } = useRouter();

    const { t } = useTranslation('forms');
    const mode = defineMode(asPath);

    const { errors, isDirty } = useFormState();
    const { getValues } = useFormContext();

    const formId = getValues('fields.ts$form');
    const ticketFields = useFieldDefinitionListFromAgentForm(Number(formId));
    const currentAgentForm = useAgentFormById(Number(formId));

    if (!isDirty && mode === 'edit') return [];

    const requiredToSubmitFields = ticketFields
        .filter((field) => {
            const fieldRuleOnForm: UIFieldRuleOnForm = currentAgentForm?.fields?.find(getFieldRuleByKey(field));
            if (fieldRuleOnForm?.listenedConditionOnForm) {
                if (
                    fieldRuleOnForm?.listenedConditionOnForm?.value.includes(
                        getValues(hookFormFriendlyFieldKey(fieldRuleOnForm?.listenedConditionOnForm?.conditionFieldKey))
                    )
                ) {
                    switch (fieldRuleOnForm?.listenedConditionOnForm?.action?.required?.type) {
                        case FieldRequirementTypeMap.TRUE:
                            return true;
                        case FieldRequirementTypeMap.FALSE:
                            return false;
                        case FieldRequirementTypeMap.TARGET_STATUS:
                            if (
                                fieldRuleOnForm?.listenedConditionOnForm?.action?.required?.ids.includes(
                                    getValues('fields.ts$status')
                                )
                            ) {
                                return true;
                            }
                            return false;
                        default:
                            false;
                    }
                    return fieldRuleOnForm?.listenedConditionOnForm?.action.required;
                } else return false;
            }
            return (
                (fieldRuleOnForm?.required.type === FieldRequirementTypeMap.TRUE ||
                    field.key.replaceAll('fields.', '').replace('.', '$') in (errors?.fields ?? {})) &&
                field.permission !== 'END_USER_ONLY' &&
                field.key !== 'ts.creator'
            );
        })
        .map((field) => {
            return {
                key: hookFormFriendlyFieldKey(field.key),
                name: field.name,
                value: getValues(hookFormFriendlyFieldKey(field.key)),
                translatedName: TicketSystemfieldNamesMap.includes(field.name) ? t(field.name as any) : field.name
            };
        })
        .filter((field) => {
            return !field.value || field.key.replaceAll('fields.', '') in (errors?.fields ?? {});
        });
    if (mode === 'create' && !getValues('comment.body')) {
        requiredToSubmitFields.push({
            key: 'comment.body',
            name: 'comment',
            value: getValues('comment.body'),
            translatedName: t(`Comment`)
        });
    }
    // console.log(`getErrorContent , requiredToSubmitFields:`, requiredToSubmitFields);
    return requiredToSubmitFields;
};

export default useRequiredFormFields;
